import React from 'react';
import ReportDrilldownPage from './ReportDrilldownPage';

const StockItemDrilldownReport = () => <ReportDrilldownPage type="stock-item" />;

export default StockItemDrilldownReport;
